import './Header.scss';

import { b2x } from '@b2x/react/src';
import React from 'react';

import { useAppContext } from './AppContext';
import { Button } from './Button';
import { Container } from './Container';
import logo from './images/logo.svg';

export interface HeaderProps {}

export const Header = (props: HeaderProps) => {
  const [localeBoxVisible, setLocaleBoxVisible] = React.useState<boolean>(false);
  const { hideHeader } = useAppContext();

  const toggleLocaleBoxVisible = React.useCallback(() => {
    setLocaleBoxVisible((prevState) => !prevState);
  }, []);

  return (
    <>
      {!hideHeader && (
        <div className="sticky-top header">
          <div className="bg-primary header-inner">
            <Container>
              <b2x.Row alignItems={'center'}>
                <b2x.Col>
                  <b2x.router.Link to="https://store.asroma.com/">
                    <b2x.Image className="" src={logo} />
                  </b2x.router.Link>
                </b2x.Col>
                <b2x.Col className="text-end">
                  <LocaleToggle localeBoxVisible={localeBoxVisible} toggleLocaleBoxVisible={toggleLocaleBoxVisible} />
                </b2x.Col>
              </b2x.Row>
            </Container>
          </div>
          {localeBoxVisible && <LocaleBox toggleLocaleBoxVisible={toggleLocaleBoxVisible} />}
        </div>
      )}
    </>
  );
};

interface LocaleToggleProps {
  localeBoxVisible: boolean;
  toggleLocaleBoxVisible(): void;
}

const LocaleToggle = ({ localeBoxVisible, toggleLocaleBoxVisible }: LocaleToggleProps) => {
  const { locale, shippingCountry } = b2x.useAppContext();

  return (
    <Button
      alignItems="center"
      className="text-white"
      iconStart={{ name: 'translate', size: 25 }}
      label={locale && shippingCountry && <span>{locale.languageCode}</span>}
      onClick={toggleLocaleBoxVisible}
      size="small"
      variant="blank"
    />
  );
};

interface LocaleBoxProps {
  toggleLocaleBoxVisible(): void;
}

const LocaleBox = ({ toggleLocaleBoxVisible }: LocaleBoxProps) => {
  return (
    <Box onCloseButtonClick={toggleLocaleBoxVisible}>
      <div className="row justify-content-center text-center py-5">
        <div className="col-8 col-md-6 col-lg-4">
          <b2x.LocaleForm />
        </div>
      </div>
    </Box>
  );
};

interface BoxProps {
  children?: React.ReactNode;
  onCloseButtonClick(): void;
}

const Box = ({ children, onCloseButtonClick }: BoxProps) => {
  b2x.useKeyPress('Escape', onCloseButtonClick);

  const ref = React.useRef<HTMLDivElement>(null);

  const handleOutsideClick = React.useCallback(() => {
    onCloseButtonClick();
  }, [onCloseButtonClick]);

  b2x.useOutsideClickHandler(ref, handleOutsideClick);

  return (
    <div className="box position-absolute w-100 bg-white shadow-sm" ref={ref}>
      <Container>
        <div className="d-flex justify-content-end pt-3">
          <Button iconEnd={{ name: 'delete', size: 25 }} onClick={onCloseButtonClick} variant="blank" />
        </div>
        {children}
      </Container>
    </div>
  );
};
